import { render, staticRenderFns } from "./activityFeedItem.vue?vue&type=template&id=5b689a84"
import script from "./activityFeedItem.vue?vue&type=script&lang=js"
export * from "./activityFeedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports